import { ChangeControl } from '../../../types/changeControl';

export const toReportDisplayName = (name: string, changeControl?: ChangeControl): string => {
  if (changeControl?.code && name) {
    return name.split(` - ${changeControl.code} - `).reverse()[0].trim();
  }
  return name;
};
